import React from 'react';

// Utilities
import extendClassNameWithModifier from '../../../../../lib/bemUtils/bem';

export const FormsRowModifier = {
  TWO_COLUMNS: 'form-row--2columns',
  BLOCK: 'form-row--block',
  TWO_DATETIMES: 'form-row--2datetimes',
  RIGHT: 'form-row--right',
  NO_MARGIN: 'form-row--no-margin',
  BORDER_TOP: 'form-row--border-top',
  BORDER_TOP_SMALL: 'form-row--border-top-small',
  VERTICAL_CENTER: 'form-row--vertical-center',
  HORIZONTAL_CENTER: 'form-row--horizontal-center',
};

type FormsRowProps = {
  modifier?: string | string[];
  children: React.ReactNode;
};

/** Row in a form that can be modified */
export default function FormsRow(props: FormsRowProps) {
  return <div className={extendClassNameWithModifier('form-row', props.modifier)}>{props.children}</div>;
}
